var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-counter"},[_c('p',{staticClass:"notification-counter__number",class:{ double: _vm.counterValue.toString().length > 1 }},[_vm._v(" "+_vm._s(_vm.counterValue)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }